export default "__VITE_ASSET__DojZVZ7L__"